import React from "react";
import { useLocation } from "react-router";

// sets max width and max height for all pages
export function ScreenHeight({ children }) {
  const { pathname } = useLocation();
  const maxWidthConditions = ["videoplayer", "Topics", "topics"];
  const maxWidth =
    maxWidthConditions.some((cond) => pathname.includes(cond)) || fullWidthPages.some((path) => pathname === path)
      ? ""
      : "maxw-1100";
  const screenHeight = pathname.includes("videoplayer") ? "" : "screen-height";

  return <div className={`${maxWidth} ${screenHeight}`}>{children}</div>;
}

// full width page list:
const fullWidthPages = [
  "/public/Analyst_Directory",
  "/Home",
  "/Economics",
  "/Equity",
  "/FX",
  "/Rates",
  "/SP__Credit",
  "/Macro Strategy",
  "/Quants",
  "/Equity_Coverage",
  "/Analyst",
];
